<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <account-form />
      </div>
    </div>
  </section>
</template>

<script>
import accountForm from './Temp/AccountFormTemp.vue'

export default {
  name: 'Tables',
  components: {
    'account-form': accountForm
  },
  methods: {
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>




// WEBPACK FOOTER //
// CrAccount.vue?4c1d392b